/* This is for ajio.com production */
module.exports = {
  endpoints: {
    category: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    capsulecp: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    topSearches: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'http://pdpaggregator-internal.services.ajio.com/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://pdpaggregator-internal.services.ajio.com/aggregator/pdp/serviceability'
    },
    curatedPage: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://sf.ajio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    newdesignhomepage: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://sf.ajio.ril.com/storefront/cms/component'
    },
    runtimeLocale: {
      href: 'http://sf.ajio.ril.com/storefront/cms/locale'
    },
    runtimeNavigationDesktop: {
      href: 'http://sf.ajio.ril.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://cms-editor.ajio.ril.com/cms-editor/v1/navigation/preview'
    },
    landingPageRuntimePreview: {
      href: 'http://cms-editor.ajio.ril.com/cms-editor/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://cms-editor.ajio.ril.com/cms-editor/v1/page/archive'
    },
    newcategoryselection: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    navigationmobile: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    minicart: {
      href: 'http://sf.ajio.ril.com/cart/rollover/json/MiniCart'
    },
    wishlist: {
      href: 'http://sf.ajio.ril.com/addToWishlistAjax'
    },
    leaderBoard: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/oauth/token'
    },
    generateLoginOTP: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signInSocial: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    selfcareInitChat: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    selfcarefaq: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    setNewPassword: {
      href:
        'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://sf.ajio.ril.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href:
        'http://gcpcms.services.ajio.jio.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://sizechart.services.ajio.com/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://assets.ajio.com/snoop/kioskIPWhitelist.json'
    },
    roadblock: {
      href:
        'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    submitAssistantId: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    signUpKiosk: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    kioskEntryPage: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'http://identity-internal.services.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href: 'http://pdpaggregator-internal.services.ajio.com/aggregator/edd/checkDeliveryDetails'
    },
    checkDeliveryDetailsV2: {
      href: 'http://pdpaggregator-internal.services.ajio.com/aggregator/pdp/scopedView'
    },
    checkServiceableCart: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'https://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    flashSaleApiUrl: {
      href: 'http://flashsale-internal.services.ajio.com/flashsale'
    },
    flashSaleUrl: {
      href: 'https://flashsale.services.ajio.com/flashsale'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment.services.ajio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    uaasLoginToken: {
      href: 'http://uaas.ajio.com/uaas/jwt/token/client'
    },
    uaasAccountCheck: {
      href: 'http://uaas.ajio.com/uaas/accountCheck'
    },
    uaasGetProfile: {
      href: 'http://uaas.ajio.com/uaas/users/current'
    },
    uaasGenerateLoginOtp: {
      href: 'http://uaas.ajio.com/uaas/login/sendOTP'
    },
    uaasSessionClear: {
      href: 'http://uaas.ajio.com/uaas/users'
    },
    uaasSignupAndSocial: {
      href: 'http://uaas.ajio.com/uaas/registerUser'
    },
    uaasSignupAndSocialNewDesign: {
      href: 'http://uaas.ajio.com/uaas/newAppRegisterUser'
    },
    uaasSignInSocial: {
      href: 'http://uaas.ajio.com/uaas/login/socialLogin'
    },
    uaasUpdateUserDetails: {
      href: 'http://uaas.ajio.com/uaas/users/updateUser/details'
    },
    uaasRefreshToken: {
      href: 'http://uaas.ajio.com/uaas/jwt/token/refresh'
    },
    uaasLogin: {
      href: 'http://uaas.ajio.com/uaas/login'
    },
    uaasMyJioLogin: {
      href: 'http://uaas.ajio.com/uaas/myjio/login'
    },
    uaasGetUserInfo: {
      href: 'http://uaas.ajio.com/uaas/users/getUserProfileByEmailId'
    },
    uaasUserInfoOtp: {
      href: 'http://uaas.ajio.com/uaas/users/editaddress'
    },
    uaasEmailUpdateOtp: {
      href: 'http://uaas.ajio.com/uaas/update/sendOTP'
    },
    uaasEmailVerifyOtp: {
      href: 'http://uaas.ajio.com/uaas/update/verifyOTP'
    },
    uaasMobileUpdate: {
      href: 'http://uaas.ajio.com/uaas/users/update/mobileNumber/request'
    },
    uaasMobileUpdateCancel: {
      href: 'http://uaas.ajio.com/uaas/users/updateMobileNumber/cancel'
    },
    uassGenerateVerifyOtp: {
      href: 'http://uaas.ajio.com/uaas/update/sendOTP'
    },
    uassVerifyMobileNumberOtp: {
      href: 'http://uaas.ajio.com/uaas/update'
    },
    uassFetchEmailByUrl: {
      href: 'http://uaas.ajio.com/uaas/fetchEmailByURL'
    },
    generateCaptchaMobileRestore: {
      href: 'http://uaas.ajio.com/uaas/generate/captcha'
    },
    generateEmailForRestoreMobile: {
      href: 'http://uaas.ajio.com/uaas/mobileUpdate/generateEmail'
    },
    fetchBankTransferStatus: {
      href: 'https://payment.services.ajio.com/payment-engine/api/v1/refund/bank-transfer-status'
    },
    uaasVerfiyEmailInfo: {
      href: 'http://uaas.ajio.com/uaas/users/verifyEmail'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaas.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV4: {
      href: 'http://uaas.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaas.ajio.com/uaas/users/verifyTaxPayerId'
    },
    relevantProductWidget: {
      href: 'http://sf.ajio.ril.com/rilfnlwebservices/v3/rilfnl/products/category'
    },
    accountDelete: {
      href: 'http://sf.ajio.ril.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    membershipDetails: {
      href: 'http://api-internal.ajio.jio.com/membership/runtime'
    },
    jioAdsSapiApi: {
      href: 'https://mercuryads.jio.com/delivery/sapi.php'
    },
    productDeliveryTypeRush: {
      href: 'http://pdpaggregator-internal.services.ajio.com/aggregator/pdp/deliveryType'
    },
    uaasB2BUsers: {
      href: 'http://uaas.ajio.com/uaas/b2b/users'
    },
    recommendationWidgetOsmos: {
      href: 'http://sf.ajio.com//rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    },
    recommendationTrendsVibes: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/recommendation/v1/trends'
    },
    crossSellCartRecommendations: {
      href: 'http://gcpsearch-internal.services.ajio.jio.com/searchservices/v1/cross-sell/recommendations'
    },
    galleriGenerateTokenAPIURL: {
      href: 'http://uaas.ajio.com/uaas/v1/creator-commerce/auth-token'
    }
  },
  properties: {
    version: '01.03.00',
    environment: 'PRODUCTION',
    siteUrl: 'https://www.ajio.com',
    parentUrl: 'https://www.ajio.com',
    // parentUrl: 'http://localhost:3000',
    baseImgUrl: 'https://assets.ajio.com',
    assetUrl: 'https://assets.ajio.com',
    // assetUrl: 'http://localhost:3000',
    imageBaseUrl: 'https://assets.ajio.com',
    // imageBaseUrl: 'http://localhost:3000',
    apiUrl: 'http://sf.ajio.ril.com',
    gamificationApiUrl: 'http://10.129.76.167/gamification',
    paymentURL: 'https://payment.services.ajio.com',
    loginPageURL: 'https://login.web.ajio.com',
    // loginPageURL: 'http://localhost:3000',
    luxeURL: 'https://luxe.ajio.com',
    streetURL: 'https://street.ajio.com',
    luxeGoogleUrl: 'https://luxe.ajio.com',
    wishlistUrl: 'http://sf.ajio.ril.com',
    pAPI: 'https://payment.services.ajio.com',
    npeBaseUrl: 'http://runtime.promoengine.services.ajio.com',
    cemUrl: 'https://www.ajio.com/cem',
    previewCheck: false,
    gtmCode: '5XMX63',
    optimizeID: 'OPT-PQFR68S',
    GAID: 'UA-68002030-1',
    APIErrorGAID: 'UA-68002030-8',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    dataGrinchAppKey: 'app5b30be1f0e5bf814621703f9',
    rumMOKey: 'c58a39eb46bfd43b62704a0ecf8d6fd8',
    pe: 'ON', // "OFF" for turning OFF
    timeout: 25000,
    timeoutNode: 15000,
    timeoutClient: 40000,
    dropAtStore: 'ON',
    gpayAppticker: 'ON', // ON = hide, OFF = show
    gpayRoadBlock: 'ON', // ON = hide, OFF = show
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'OFF',
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    downloadInvoiceFlag: true,
    cleverTapID: '48K-4R4-K84Z',
    firebaseConfig: JSON.stringify({
  
    }),
    firebaseConfig_M: JSON.stringify({
 
    }),
    webAppVersion: '1.0.0',
    segment_api_write_key : 'hKdcCBW9TrvuhEehZTBSSaJLGNhLRasy',
    amplitude_experiment_server_key: 'server-AblRWcufkysyE4w4XxpxB7N8XuL517jZ',
    botifyWebsiteId: 'UO4YE7',
    amplitude_api_key: '9ac8bf1364978b2734f25fe8793278c8',
    fyndConfig: {
      applicationID: '6920511ba88a0b4351d486dc',
      applicationToken: 'IHh6B1LQN',
      fyndApiBaseUrl: 'https://www.ajio.com',
      storeIds: {
        ajio: null,
        luxe: '69cb841a14a7a12382193ebc',
        ajiogram: '69afbc548c950b22d77b20fb',
        rush: '69ce6d49a6a440f230dbd7bb'
      }
    }
  }
};